import { Avatar, Box } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useRef, useState } from 'react';
import useTestCartData from '../hooks/useTestCartData';

const PrescriptionSelector = () => {
    const {orderInfo, prescription, updateCartOrderData} = useTestCartData();
    const [previewUrl, setPreviewUrl] = useState(null);
    const [fileType, setFileType] = useState(null);
    const fileRef = useRef();

    const selectPrescription = () => {
        fileRef.current.click();
    };

    const handlePrescription = (e) => {
        const fileData = e.target.files[0];
        if (fileData) {
            updateCartOrderData({prescription: fileData});
            const type = fileData.type;
            setFileType(type);

            if (
                type === 'image/png' ||
                type === 'image/jpeg' ||
                type === 'image/jpg' ||
                type === 'application/pdf'
            ) {
                const url = URL.createObjectURL(fileData);
                setPreviewUrl(url);
            } else {
                setPreviewUrl(null);
            }
        }
    };

    const deselectFile = () => {
        updateCartOrderData({prescription: ''});
        setPreviewUrl(null);
        setFileType(null);
    };

    useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
            }
        };
    }, [previewUrl]);

    const previewUI = () => {
        if (!previewUrl) {
            return (
                <Avatar sx={{ height: 64, width: 64}} style={{cursor: 'pointer'}} onClick={selectPrescription}>
                    <PhotoCameraIcon />
                    <input
                        type='file'
                        accept='image/png, application/pdf, image/jpeg'
                        hidden={true}
                        onChange={handlePrescription}
                        ref={fileRef}
                    />
                </Avatar>
            );
        }

        const previewPrescription = () => {
            if (fileType === 'application/pdf') {
                return (
                    <iframe
                        src={previewUrl}
                        title="PDF Preview"
                        width="80%"
                        height="100px"
                        style={{ border: '1px solid #ccc' }}
                    />
                );
            }

            return (
                <img
                    src={previewUrl}
                    alt="Preview"
                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px' }}
                />
            );
        };

        return (
            <Box mt={2}>
                {previewPrescription()}
            </Box>
        );
    };

    const prescriptionDeselector = prescription && (
        <p className='selected-prescription'>
            {prescription.name}
            <CloseIcon onClick={deselectFile} />
        </p>
    );

    const uploadLabelClass = `descriptor ${orderInfo?.testType === 1 ? 'required-label' : ''}`;
    return (
      <div className="flex-gap" style={{marginTop: '1rem'}}>
            <Box className="prescription-upload-wrapper">
                {previewUI()}
                <p className={uploadLabelClass}>Upload</p>
            </Box>
            {prescriptionDeselector}
        </div>
    );
};

export default PrescriptionSelector;